export default __webpack_public_path__ + "static/backgroundGallery-bac3c75f2172c71846bdb53c6e1a49e8.jpg";